import { render, staticRenderFns } from "./DataUser.vue?vue&type=template&id=3d324678&scoped=true"
import script from "./DataUser.vue?vue&type=script&lang=js"
export * from "./DataUser.vue?vue&type=script&lang=js"
import style0 from "./DataUser.vue?vue&type=style&index=0&id=3d324678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d324678",
  null
  
)

export default component.exports